/* src/pages/ServicesPage.module.css */
.main { padding-top: var(--nav-height); }

.pageHero {
  padding: 5rem 0 4rem;
  background:
    radial-gradient(ellipse 60% 60% at 80% 40%, rgba(26,127,193,0.09) 0%, transparent 65%),
    var(--dark2);
  border-bottom: 1px solid var(--border);
  text-align: center;
}
.breadcrumb { display:flex; align-items:center; justify-content:center; gap:0.5rem; font-size:13px; color:var(--muted); margin-bottom:1.5rem; }
.breadcrumb a { color:var(--muted); transition:color var(--transition); }
.breadcrumb a:hover { color:var(--blue-light); }
.breadSep { color:var(--muted2); }
.pageH1 { font-size:clamp(36px,6vw,72px); margin: 1.5rem auto 1rem; }
.pageSubtitle { font-size:18px; max-width:600px; margin:0 auto; }

.serviceSection { padding:100px 0; border-bottom:1px solid var(--border); }
.serviceSectionAlt { background:var(--dark2); }

.serviceLayout {
  display:grid; grid-template-columns:1fr 1fr; gap:5rem; align-items:center;
}
.serviceLayoutSingle {
  grid-template-columns:1fr;
}
.serviceLayoutReverse { direction:rtl; }
.serviceLayoutReverse > * { direction:ltr; }

.serviceBody {}
.serviceHeader { margin-bottom:1.5rem; }
.serviceNum {
  font-family:'Bebas Neue', sans-serif; font-size:100px; line-height:0.85;
  color:rgba(63,168,232,0.06); display:block; margin-bottom:-10px; user-select:none;
}
.serviceTitle { font-size:clamp(26px,3.5vw,42px); line-height:1.1; margin-top:0.5rem; }

.featureGrid { display:grid; grid-template-columns:1fr 1fr; gap:0.75rem; }
.featureChip {
  display:flex; align-items:center; gap:8px;
  background:var(--card); border:1px solid var(--border);
  border-radius:8px; padding:10px 14px;
  font-size:13px; font-weight:500; color:var(--text);
}

.serviceImg {
  aspect-ratio:4/3.5; border-radius:var(--radius-lg);
  background:var(--card2); border:1px dashed var(--border-strong);
  display:flex; flex-direction:column; align-items:center; justify-content:center;
  gap:0.75rem; font-size:13px; color:var(--muted); position:relative; overflow:hidden;
  width: 100%;
  min-height: 420px;
  padding: 0;
}
.serviceImgGym {
  position: relative;
  display: block;
  padding: 0;
  background: transparent;
  border: none;
}
.serviceImgSnack,
.serviceImgBar {
  border: none;
  background: transparent;
}
.serviceImgPhotoGym,
.serviceImgPhotoFill {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
  display: block;
  z-index: 0;
}
.serviceImgBadge {
  position:absolute; top:16px; right:16px;
  z-index: 1;
  background:var(--card); border:1px solid var(--border-strong);
  border-radius:8px; padding:8px 14px;
  font-size:12px; font-weight:700; letter-spacing:0.5px; color:var(--blue-light);
}
.serviceImgGalleryWrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.serviceImgGallery {
  display: flex;
  gap: 0.75rem;
  width: 100%;
  height: 100%;
  padding: 0.75rem;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
}
.serviceImgGallery::-webkit-scrollbar {
  height: 8px;
}
.serviceImgGallery::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.15);
  border-radius: 999px;
}
.galleryNavButton {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 44px;
  height: 44px;
  font-size: 22px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.3);
  background: rgba(0,0,0,0.65);
  color: #fff;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background var(--transition), transform var(--transition), box-shadow var(--transition);
}
.galleryNavButton:hover {
  background: rgba(0,0,0,0.55);
  transform: translateY(-50%) scale(1.05);
}
.galleryNavButtonRight {
  right: 10px;
}
.galleryNavButton:not(.galleryNavButtonRight) {
  left: 10px;
}
.serviceImgPhoto {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--radius-lg);
  display: block;
}
.serviceImgPhotoSmall {
  flex: 0 0 100%;
  width: 100%;
  min-height: 100%;
  object-fit: cover;
  border-radius: 14px;
  display: block;
  scroll-snap-align: center;
}
.serviceImgBadge {
  position:absolute; top:16px; right:16px;
  background:var(--card); border:1px solid var(--border-strong);
  border-radius:8px; padding:8px 14px;
  font-size:12px; font-weight:700; letter-spacing:0.5px; color:var(--blue-light);
}

.pricingCards { display:grid; grid-template-columns:1fr 1fr; gap:2rem; }
.pricingCard {
  background:var(--card); border:1px solid var(--border);
  border-radius:var(--radius-lg); padding:2.5rem;
}
.pricingFeatured {
  border-color:rgba(63,168,232,0.4);
  background:linear-gradient(135deg,rgba(26,127,193,0.08) 0%,rgba(61,187,47,0.05) 100%);
  position:relative;
}
.pricingFeatured::before {
  content:'MOST POPULAR'; position:absolute; top:1.5rem; right:1.5rem;
  background:linear-gradient(135deg,var(--blue),var(--green-dark));
  color:#fff; font-size:10px; font-weight:700; letter-spacing:1.5px;
  padding:4px 12px; border-radius:4px;
}
.pricingPrice {
  font-family:'Bebas Neue', sans-serif; font-size:64px; letter-spacing:2px;
  background:linear-gradient(135deg,var(--blue-light),var(--green));
  -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text;
  line-height:1;
}
.pricingPeriod { color:var(--muted); font-size:14px; margin-bottom:1.5rem; }
.pricingList { list-style:none; display:flex; flex-direction:column; gap:0.75rem; margin-bottom:2rem; }
.pricingList li { display:flex; gap:10px; font-size:14px; color:var(--muted); }
.pricingList li::before { content:'✓'; color:var(--green); font-weight:700; flex-shrink:0; }

.venuesSection {
  padding:100px 0; background:var(--dark2); border-top:1px solid var(--border);
}
.venuesGrid { display:grid; grid-template-columns:repeat(3,1fr); gap:1.5rem; }
.venueCard {
  background:var(--card); border:1px solid var(--border);
  border-radius:var(--radius); padding:1.5rem; text-align:center;
  transition:border-color var(--transition), transform var(--transition);
}
.venueCard:hover { border-color:var(--border-strong); transform:translateY(-4px); }

@media (max-width:900px) {
  .serviceLayout { grid-template-columns:1fr; gap:2.5rem; }
  .serviceLayoutReverse { direction:ltr; }
  .pricingCards { grid-template-columns:1fr; }
  .venuesGrid { grid-template-columns:1fr 1fr; }
  .featureGrid { grid-template-columns:1fr; }
  .serviceImg { min-height: auto; aspect-ratio: auto; height: auto; }
  .serviceImgGallery { padding: 0.5rem 0; }
  .serviceImgPhotoSmall, .serviceImgPhotoFill, .serviceImgPhoto, .serviceImgPhotoGym { height: auto; min-height: auto; object-fit: contain; }
}
@media (max-width:600px) {
  .venuesGrid { grid-template-columns:1fr; }
  .serviceImg { padding: 0.5rem; }
}
